import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Layout from './Layout';

function RetailInvestor(): JSX.Element {
    return (
        <Layout section='retail-investor'>
            <h1>Registration</h1>
            <div className='content-box'>
                <h3>Retail Investor</h3>
                <p>Sorry only Wholesale and Sophisticated investors are eligible to participate in the Income Trust.</p>
                <p>Our retail fund is open to all investors who select and manage investments online starting from $5,000.</p>
                <p>Target returns from <strong>5 to 9%</strong> pa*.</p>
                <p>Be sure to read the PDS and consider all risks while investing. Target returns and repayment of capital are not guaranteed.</p>
                <Link to='/marketplace' className='continue'>
                    <Button variant='primary'>Continue to Retail Fund</Button>
                </Link>
            </div>
        </Layout>
    );
}

export default RetailInvestor;
